import React from 'react'
import { connect } from 'react-redux'

import ReactModal from 'react-modal'
import { translate } from 'react-i18next'

import styled from 'styled-components'
import { ReactComponent as IconCloseFilter } from 'assets/img/icon/ic_close_filter.svg'
import PerfectScrollbar from 'react-perfect-scrollbar'
// import { fromBinary } from 'utils';

import { ReactComponent as IconDate } from 'assets/img/icon/ic_date.svg'
import { ReactComponent as IconImport } from 'assets/img/icon/ic_import.svg'

//#region
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '640px',
    height: '640px',
    transform: 'translate(-50%, -50%)',
    bottom: 'auto',
    backgroundColor: 'var(--bg-th-even)',
    border: 'none',
  },
}

const StyleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  background: ${(props) => (props.theme === 'dark' ? '#1c192c' : '#ffffff')};
  border-radius: 8px;
`

const StyleHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: var(--half_white);
  font-weight: 500;
  font-size: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid #4e4d62;
`

const StyleBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 24px 16px;
  height: calc(100% - 58px);
`

const StyleContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  label {
    line-height: 150%;
    color: #f0b90b;
    font-weight: 700;
    font-size: 24px;
    //color: ${(props) => (props.theme === 'dark' ? '#ececec' : '#000000')};
  }

  div.sub-header {
    display: flex;
    align-items: center;
    padding: 10px 0 18px;
    color: #818181;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    span {
      padding-left: 5px;
      align-self: end;
    }
  }

  div.file-attach {
    padding-top: 24px;
    display: flex;
    flex-direction: column;

    label {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: ${(props) => (props.theme === 'dark' ? '#ececec' : '#000000')};
    }

    a {
      display: grid;
      grid-template-columns: 25px auto;
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      color: #03ca6b;

      border: 1px solid #03ca6b;
      border-radius: 100px;
      padding: 8px 16px;

      svg {
        align-self: center;
      }
    }
  }

  .scrollbar-container{
    height: calc(100% - 110px);
  }
`

const StyledDivTable = styled.div`
  position: relative;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: ${(props) => (props.theme === 'dark' ? '#ececec' : '#000000')};

  div.col-md-12 {
    padding: 0;
    font-size: 14px;
  }
`
//#endregion

function EventDetailModal(props) {
  const { onClose, t, data, theme } = props

  // console.log(decodeURIComponent(escape(window.atob(data.content))))

  console.log(data)

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      //   shouldCloseOnOverlayClick={true}
      style={customStyles}
    >
      <StyleContainer theme={theme}>
        <StyleHeader>
          {t('algo.ptcp.txt-Events-Detail')}
          <a className="ml-auto" onClick={onClose}>
            <IconCloseFilter />
          </a>
        </StyleHeader>
        <StyleBody>
          <StyleContent theme={theme}>
            <label theme={theme}>{data.title}</label>
            <div className="sub-header">
              <IconDate />
              <span>{data.tradeDate}</span>
            </div>
            <PerfectScrollbar
              className="w-100"
            >
              {data.content ? (
                <StyledDivTable
                  theme={theme}
                  dangerouslySetInnerHTML={{
                    __html:
                      decodeURIComponent(escape(window.atob(data.content))) ||
                      '',
                  }}
                >
                  {/* {decodeURIComponent(escape(window.atob(data.content)))} */}
                </StyledDivTable>
              ) : (
                <div></div>
              )}
              {data.attach && data.attach.split('|').length > 0 && (
              <div className="file-attach">
                <label theme={theme}>{t('algo.ptcp.txt-apendix-doc')}</label>
                {data.attach.split('|').map((item, index) => (
                  <a
                    key={index}
                    target={'_blank'}
                    href={`http://files.algoplatform.vn/algonews?container=${
                      data.container
                    }&vos_path=${
                      data.filePath
                    }&file_name=${item}&timestamp=${Date.now()}`}
                  >
                    <IconImport />
                    <span>{item}</span>
                  </a>
                ))}
              </div>
            )}
            {data.source && (
              <div className="d-flex txt-content" style={{marginTop: '32px', fontStyle: 'italic'}}>
                <span className='mr-2'>Nguồn tin:</span>
                <span style={{fontWeight: '700'}}>{data.source}</span>
              </div>
            )}
            </PerfectScrollbar>
          </StyleContent>
        </StyleBody>
      </StyleContainer>
    </ReactModal>
  )
}

export default connect()(translate('translations')(EventDetailModal))
